var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_8397",
    "data-name": "\\u7EC4 8397",
    transform: "translate(-5260 3814)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u5706\\u89D2\\u77E9\\u5F62_6_\\u62F7\\u8D1D",
    "data-name": "\\u5706\\u89D2\\u77E9\\u5F62 6 \\u62F7\\u8D1D",
    d: "M1032,526h0l2.677,1.586a8.592,8.592,0,0,0,3.323,1.08v7.111c0,3.436-4.286,6.222-6,6.222h0c-1.787,0-6-2.786-6-6.222v-7.111a8.085,8.085,0,0,0,3.251-1.038Z",
    transform: "translate(4238 -4339)",
    fill: "rgba(153,153,153,0.2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u5706\\u89D2\\u77E9\\u5F62_6",
    "data-name": "\\u5706\\u89D2\\u77E9\\u5F62 6",
    d: "M1024.718,540.95C1023.7,540.086,1022,538.3,1022,536v-8a9.885,9.885,0,0,0,3.793-1.167L1029,525l1.752,1,1.371.783A10.366,10.366,0,0,0,1036,528v8c0,3.9-5.027,7-7,7A7.951,7.951,0,0,1,1024.718,540.95Zm3.07-14.232-1.537.911a8.177,8.177,0,0,1-3.251,1.038v7.111a6.246,6.246,0,0,0,2.33,4.4,6.733,6.733,0,0,0,3.66,1.823H1029c1.691,0,6-2.759,6-6.223v-7.111h0a8.758,8.758,0,0,1-3.318-1.081L1029,526Zm.246,10.118-2.9-2.843a.5.5,0,0,1,0-.711.521.521,0,0,1,.725,0l2.5,2.448,3.75-4.581a.52.52,0,0,1,.724,0,.5.5,0,0,1,0,.711l-4,4.891a.508.508,0,0,1-.07.085.52.52,0,0,1-.725,0Z",
    transform: "translate(4238 -4339)",
    fill: "#999"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/安全.2484a705e8dcb644d3911a200f2a5d4b.svg";
export { ForwardRef as ReactComponent };